import { AFFECTED_SIDE_OPTIONS } from '../../ClinicalRecord/clinicalRecordOptions';

export const eventsSchema = {
  fall: {
    properties: {
      eventTimestamp: {
        type: 'date',
        required: true,
        label: 'Event Time',
      },
      affectedSide: {
        type: 'select',
        label: 'Affected Side',
        required: true,
        options: AFFECTED_SIDE_OPTIONS,
      },
      therapistComment: {
        type: 'text',
        multiline: true,
        label: 'Comment',
        required: false,
        placeholder: 'Details',
        minRows: 7,
        maxRows: 7,
      },
    },
  },
  injury: {
    properties: {
      eventTimestamp: {
        type: 'date',
        required: true,
        label: 'Event Time',
      },
      affectedSide: {
        type: 'select',
        label: 'Affected Side',
        required: true,
        options: AFFECTED_SIDE_OPTIONS,
      },
      therapistComment: {
        type: 'text',
        multiline: true,
        required: false,
        label: 'Comment',
        placeholder: 'Details',
        minRows: 7,
        maxRows: 7,
      },
    },
  },
  achievement: {
    properties: {
      eventTimestamp: {
        type: 'date',
        required: true,
        label: 'Event Time',
      },
      affectedSide: {
        type: 'select',
        label: 'Affected Side',
        required: true,
        options: AFFECTED_SIDE_OPTIONS,
      },
      therapistComment: {
        type: 'text',
        multiline: true,
        label: 'Comment',
        required: false,
        placeholder: 'Details',
        minRows: 7,
        maxRows: 7,
      },
    },
  },
  other: {
    properties: {
      eventTimestamp: {
        type: 'date',
        required: true,
        label: 'Event Time',
      },
      title: {
        type: 'text',
        label: 'Title',
        required: true,
      },
      affectedSide: {
        type: 'select',
        label: 'Affected Side',
        required: true,
        options: AFFECTED_SIDE_OPTIONS,
      },
      therapistComment: {
        type: 'text',
        multiline: true,
        required: false,
        label: 'Comment',
        placeholder: 'Details',
        minRows: 4,
        maxRows: 4,
      },
    },
  },
};

export type EventsSchemaKeys = keyof typeof eventsSchema
